// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>

<div class="click-through" style="position:absolute; width: 100%; height: 100%; display:flex; align-items: flex-end; justify-content:center;">
  <toolbar v-if="$store.state.showMainToolBar" class="get-click"></toolbar>
  <observing-panel></observing-panel>
  <template v-for="(item, i) in pluginsGuiComponents">
    <component :is="item" :key="i"></component>
  </template>
  <template v-for="(item, i) in dialogs">
    <component :is="item" :key="i + pluginsGuiComponents.length"></component>
  </template>
  <selected-object-info v-if="!appMobile && !widthMobile" class="get-click"></selected-object-info>
  <selected-object-pointer></selected-object-pointer>
  <selected-object-info-mobile v-if="appMobile || widthMobile" class="get-click mobile-select"></selected-object-info-mobile>
  <progress-bars style="position: absolute; bottom: 54px; right: 12px;"></progress-bars>
  <bottom-bar
    style="position:absolute; width: 100%; justify-content: center; bottom: 50px; display:flex; margin-bottom: 0px; padding: 0 150px;"
    class="get-click btm-bar"></bottom-bar>
</div>

</template>

<script>
import Toolbar from '@/components/toolbar.vue'
import BottomBar from '@/components/bottom-bar.vue'
import SelectedObjectInfo from '@/components/selected-object-info.vue'
import SelectedObjectPointer from '@/components/selected-object-pointer.vue'
import SelectedObjectInfoMobile from '@/components/selected-object-info-mobile.vue'
import ProgressBars from '@/components/progress-bars'
import swh from '@/assets/sw_helpers.js'

import DataCreditsDialog from '@/components/data-credits-dialog.vue'
import ViewSettingsDialog from '@/components/view-settings-dialog.vue'
import PlanetsVisibility from '@/components/planets-visibility.vue'
import LocationDialog from '@/components/location-dialog.vue'
import ObservingPanel from '@/components/observing-panel.vue'
import Vue from 'vue'

export default {
  data: function () {
    return {
    }
  },
  methods: {
  },
  computed: {
    appMobile: function () {
      var app = swh.checkApp()
      if (app) {
        return true
      } else {
        return false
      }
    },
    widthMobile: function () {
      var wi = swh.checkWidth()
      if (wi) {
        return true
      } else {
        return false
      }
    },
    pluginsGuiComponents: function () {
      let res = []
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i]
        if (plugin.guiComponents) {
          res = res.concat(plugin.guiComponents)
        }
      }
      return res
    },
    dialogs: function () {
      let res = [
        'data-credits-dialog',
        'view-settings-dialog',
        'planets-visibility',
        'location-dialog'
      ]
      for (const i in this.$stellariumWebPlugins()) {
        const plugin = this.$stellariumWebPlugins()[i]
        if (plugin.dialogs) {
          res = res.concat(plugin.dialogs.map(d => d.name))
        }
      }
      return res
    }
  },
  mounted () {
    if (document.readyState === 'complete') {
      window.MessageInvoker.postMessage(JSON.stringify({ type: 'webIsReady' }))
      if (Vue.prototype.$store.state.currentLocation.short_name === 'Unknown') {
        if (swh.checkAppVersion()) {
          window.MessageInvoker.postMessage(JSON.stringify({ type: 'location' }))
        } else {
          window.MessageInvoker.postMessage('location')
        }
      }
    }
  },
  components: { Toolbar, BottomBar, DataCreditsDialog, ViewSettingsDialog, PlanetsVisibility, SelectedObjectInfo, SelectedObjectPointer, LocationDialog, ProgressBars, ObservingPanel, SelectedObjectInfoMobile }
}
</script>

<style lang="scss" scoped>
#app .v-application .secondary {
  background-color: rgba(16, 20, 32, 0.7) !important;
}
.get-click{
  align-items: center !important;
  ::v-deep &.v-card{
    position: absolute;
    top: 15%;
    left: 10%;
    width: 370px;
    max-width: calc(100vw - 12px);
    margin: 6px
  }
  &.mobile-select{
    width: 100%;
  }
}
@media screen and (max-width: 599px){
  .get-click{
    &.btm-bar{
      bottom: 25px !important;
    }
  }
}
</style>
